document.addEventListener('DOMContentLoaded', function() {
    const selectElements = document.querySelectorAll('select[data-variant-input]');
    
    const sizeSelect = Array.from(selectElements).find(select => {
        const label = select.closest('.variant-wrapper')?.querySelector('.variant__label')?.textContent.trim();
        return label.toLowerCase() === 'size';
    });
    const customSizeDiv = document.querySelector('.custom_size_option_2');
    const hiddenInputContainer = document.querySelector('.hidden-input-container');
    
    const measurementSelects = document.querySelectorAll('.measurement-group .size_option');
    
    const optionNameInput = document.querySelector('.custom-option-name');
    const optionValueInput = document.querySelector('.custom-option-value');
    
    if (sizeSelect && customSizeDiv && hiddenInputContainer && optionNameInput && optionValueInput) {
        const updateHiddenInputs = () => {
            hiddenInputContainer.innerHTML = '';
            
            const optionName = optionNameInput.value.toLowerCase();
            const optionValue = optionValueInput.value.toLowerCase();
            const selectedValue = sizeSelect.value.toLowerCase();;
            const variantLabel = sizeSelect.closest('.variant-wrapper').querySelector('.variant__label').textContent.trim().toLowerCase();
            
            if (variantLabel === optionName && selectedValue === optionValue) {
                customSizeDiv.style.display = 'block';
                console.log('Custom Size selected:', selectedValue);
                
                measurementSelects.forEach(select => {
                    const label = select.closest('div').querySelector('.data-lable').textContent.trim();
                    const value = select.value;
                    if (value && value !== 'Select size') {
                        const input = document.createElement('input');
                        input.type = 'hidden';
                        input.className = 'size_input hidden_input';
                        input.name = `properties[${label}]`;
                        input.value = value;
                        hiddenInputContainer.appendChild(input);
                    }
                });
            } else {
                customSizeDiv.style.display = 'none';
            }
        };
        
        updateHiddenInputs();
        
        sizeSelect.addEventListener('change', updateHiddenInputs);
        measurementSelects.forEach(select => {
            select.addEventListener('change', updateHiddenInputs);
        });
    }
});